module.exports = __webpack_public_path__ + "static/1_1-5614aabe0bd33bfa4025fe77c3cf678e.png";